import React from 'react';
import classNames from 'classnames';
import Close from '@material-ui/icons/CloseRounded';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/customTagStyle';
import { primaryColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles(styles);

interface ITagProps {
	filterName?: string;
	clearAll?: boolean;
	onClick: () => void;
	label: string;
	color?: string;
	className?: string;
}

const CustomTag = ({ onClick, label, clearAll, color, className }: ITagProps) => {
	const classes = useStyles({ color });

	const tagClasses = classNames({
		[classes.root]: true,
		[classes.clearAll]: clearAll,
		[`${className}`]: !!className,
	});

	return (
		<div className={tagClasses} onClick={onClick}>
			<p className={classes.label} color={primaryColor[0]}>
				{label}
			</p>
			<Close color={'primary'} />
		</div>
	);
};

export default CustomTag;
